import { css } from '@linaria/atomic';
import { theme } from '@frontend/theme';

/**
 * Styles for the modal portal container (rendered by `ModalProvider`). Applied directly to the container
 * element via `className` instead of a global stylesheet so it can be extracted at build time.
 */
export const modalContainer = css`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 0;
  left: 0;
  z-index: ${theme.zIndex.modals};

  :focus {
    outline: none;
  }

  /* Set by ModalProvider when the app opts in (pinToViewport) and the modal is on <body>, where absolute would
     anchor to the document top (off screen when scrolled). */
  &[data-mount-target='body'] {
    position: fixed;
  }
`;

/**
 * Pins modal parts that are positioned against the page (backdrops, trays, full screen/mobile bodies) to the
 * viewport. Apply when `useModalContext().pinToViewport`, after the part's own `position` class.
 */
export const fixedToViewport = css`
  position: fixed;
`;
